import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upload-modal upload-modal--stage-selection"
}
const _hoisted_2 = { class: "upload-modal__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "upload-modal__title" }, " What do you want to upload? ", -1 /* HOISTED */)
const _hoisted_4 = { class: "form__radiogroup mb-24" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("legend", { class: "invisible" }, " Stage ", -1 /* HOISTED */)
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id", "value"]
const _hoisted_8 = { class: "upload-modal__buttons mb-16" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = {
  key: 1,
  class: "upload-modal"
}
const _hoisted_13 = {
  key: 0,
  class: "upload-modal__format-selection"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "upload-modal__format-selection-title" }, " Upload Media files ", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "upload-modal__format-selection-subtitle" }, " Please select the media you wish to upload here ", -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "upload-modal__format-buttons"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "upload-modal__format-buttons"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["upload-modal-wrapper", { 'upload-modal-wrapper--show': $setup.show }])
  }, [
    ($setup.asset && !$setup.uploading_to_virtual_tour_grid && !$setup.stage_selected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "upload-modal__close",
            "aria-label": "Close modal",
            onClick: $setup.closeModal
          }),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("fieldset", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.uploadable_stages, (uploadable_stage) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: 'stage-' + uploadable_stage,
                  for: _ctx.value,
                  class: "form__radio"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: uploadable_stage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.stage) = $event)),
                    type: "radio",
                    name: "project-status",
                    value: uploadable_stage
                  }, null, 8 /* PROPS */, _hoisted_7), [
                    [_vModelRadio, $setup.stage]
                  ]),
                  _createTextVNode(" " + _toDisplayString(uploadable_stage), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "button",
                disabled: _ctx.loading,
                onClick: $setup.closeModal
              }, " Cancel ", 8 /* PROPS */, _hoisted_9),
              _createElementVNode("button", {
                class: _normalizeClass(["button button--fill", { 'button--loading' : _ctx.loading }]),
                disabled: _ctx.loading || !$setup.stage,
                onClick: _cache[1] || (_cache[1] = $event => ($setup.stage_selected = true))
              }, " Save ", 10 /* CLASS, PROPS */, _hoisted_10)
            ]),
            (_ctx.error_message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.error_message), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "upload-modal__close",
            "aria-label": "Close modal",
            onClick: $setup.closeModal
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ($setup.upload_format === null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    ($setup.uploading_to_virtual_tour_grid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.available_media_types, (media_type) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'type-' + media_type.slug
                            }, [
                              (media_type.slug === 'virtual-tour')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("button", {
                                      class: "upload-modal__format-button upload-modal__format-button--virtual-tour",
                                      onClick: $event => ($setup.selectVirtualTour( media_type, $setup.UPLOAD_FORMAT_VIRTUAL_EXPLORE_TOUR ))
                                    }, " Virtual Tour ", 8 /* PROPS */, _hoisted_17),
                                    _createElementVNode("button", {
                                      class: "upload-modal__format-button upload-modal__format-button--animations",
                                      onClick: $event => ($setup.selectVirtualTour( media_type, $setup.UPLOAD_FORMAT_VIRTUAL_VIDEO_TOUR ))
                                    }, " Virtual Tour ", 8 /* PROPS */, _hoisted_18)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createElementVNode("button", {
                            class: "upload-modal__format-button upload-modal__format-button--stills",
                            onClick: _cache[2] || (_cache[2] = $event => ($setup.upload_format = $setup.UPLOAD_FORMAT_VIRTUAL_TOUR_IMAGE))
                          }, " Stills "),
                          _createElementVNode("button", {
                            class: "upload-modal__format-button upload-modal__format-button--animations",
                            onClick: _cache[3] || (_cache[3] = $event => ($setup.upload_format = $setup.UPLOAD_FORMAT_VIRTUAL_TOUR_VIDEO))
                          }, " Animations ")
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.available_media_types, (media_type) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'type-' + media_type.slug
                            }, [
                              (media_type.slug !== 'virtual-tour')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass(["upload-modal__format-button", 'upload-modal__format-button--' + media_type.slug]),
                                    onClick: $event => ($setup.selectFormat( media_type ))
                                  }, _toDisplayString(media_type.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_20))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("button", {
                                      class: "upload-modal__format-button upload-modal__format-button--virtual-tour",
                                      onClick: $event => ($setup.selectVirtualTour( media_type, $setup.UPLOAD_FORMAT_VIRTUAL_EXPLORE_TOUR ))
                                    }, " Virtual Tour ", 8 /* PROPS */, _hoisted_21),
                                    _createElementVNode("button", {
                                      class: "upload-modal__format-button upload-modal__format-button--animations",
                                      onClick: $event => ($setup.selectVirtualTour( media_type, $setup.UPLOAD_FORMAT_VIRTUAL_VIDEO_TOUR ))
                                    }, " Virtual Tour ", 8 /* PROPS */, _hoisted_22)
                                  ], 64 /* STABLE_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                  ]))
                : ($setup.is_image_upload)
                  ? (_openBlock(), _createBlock($setup["ImageUploadComponent"], {
                      key: 1,
                      project: $setup.project,
                      asset: $setup.asset,
                      stage: $setup.stage,
                      "format-locked": $setup.format_locked,
                      "selected-media-type-id": $setup.selected_media_type_id,
                      onBackToFormatSelect: _cache[4] || (_cache[4] = $event => ($setup.upload_format = null))
                    }, null, 8 /* PROPS */, ["project", "asset", "stage", "format-locked", "selected-media-type-id"]))
                  : ($setup.is_video_upload || $setup.is_virtual_video_tour_upload)
                    ? (_openBlock(), _createBlock($setup["VideoUploadComponent"], {
                        key: 2,
                        project: $setup.project,
                        asset: $setup.asset,
                        stage: $setup.stage,
                        format: $setup.upload_format,
                        "selected-media-type-id": $setup.selected_media_type_id,
                        "format-locked": $setup.format_locked,
                        onBackToFormatSelect: _cache[5] || (_cache[5] = $event => ($setup.upload_format = null))
                      }, null, 8 /* PROPS */, ["project", "asset", "stage", "format", "selected-media-type-id", "format-locked"]))
                    : ($setup.is_virtual_explore_tour_upload)
                      ? (_openBlock(), _createBlock($setup["ExploreUploadComponent"], {
                          key: 3,
                          project: $setup.project,
                          asset: $setup.asset,
                          stage: $setup.stage,
                          format: $setup.upload_format,
                          "selected-media-type-id": $setup.selected_media_type_id,
                          "format-locked": $setup.format_locked,
                          onBackToFormatSelect: _cache[6] || (_cache[6] = $event => ($setup.upload_format = null))
                        }, null, 8 /* PROPS */, ["project", "asset", "stage", "format", "selected-media-type-id", "format-locked"]))
                      : ($setup.is_virtual_tour_image_upload)
                        ? (_openBlock(), _createBlock($setup["VirtualTourImageUploadComponent"], {
                            key: 4,
                            project: $setup.project,
                            asset: $setup.asset,
                            onBackToFormatSelect: _cache[7] || (_cache[7] = $event => ($setup.upload_format = null))
                          }, null, 8 /* PROPS */, ["project", "asset"]))
                        : ($setup.is_virtual_tour_video_upload)
                          ? (_openBlock(), _createBlock($setup["VirtualTourVideoUploadComponent"], {
                              key: 5,
                              project: $setup.project,
                              asset: $setup.asset,
                              onBackToFormatSelect: _cache[8] || (_cache[8] = $event => ($setup.upload_format = null))
                            }, null, 8 /* PROPS */, ["project", "asset"]))
                          : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]))
  ], 2 /* CLASS */))
}